import { render, staticRenderFns } from "./PicklPurchases.vue?vue&type=template&id=b4cbfdf8&scoped=true&"
import script from "./PicklPurchases.vue?vue&type=script&lang=js&"
export * from "./PicklPurchases.vue?vue&type=script&lang=js&"
import style0 from "./PicklPurchases.vue?vue&type=style&index=0&id=b4cbfdf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbfdf8",
  null
  
)

export default component.exports